const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/certificates",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    add({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    update({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/update`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    types({ dispatch, state, rootState }) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/types`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    "add-type"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/types/add`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    "update-type"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/types/update`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    "types-add"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/types/add`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    "types-update"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/types/update`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    "kpi-bonuses"({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/kpi-bonuses?${serialize(options || {})}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    "kpi-bonus-add"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/kpi-bonus/add`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    "kpi-bonus-update"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/kpi-bonus/update`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    "kpi-bonus-delete"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/kpi-bonus/delete`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    "upload-certificate-file"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/upload-certificate-file`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    "get-by-id"({ dispatch, state, rootState }, id) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/get-by-id/${id}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
  },
};
